<template>
  <v-card>
    <v-card-title>
      Dodaj nowy oddział
    </v-card-title>
    <v-card-text>
      <CompanyBranchAddEdit
          :companyId="this.companyId"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import CompanyBranchAddEdit from "@/components/price-list/CompanyBranchAddEdit";

export default {
  props: {
    companyId: {
      type: [String],
      required: true,
    }
  },
  components: {
    CompanyBranchAddEdit,
  },
}
</script>